import React, { useEffect} from 'react';
import Path from './../../../assets/images/Path.svg';
import BackArrow from '../../atoms/backArrow/backArrow';
import {  Link } from 'react-router-dom';
import backIcon from '../../assets/images/backIcon.svg';


import './terms.scss';


let terms = `UNDERTAKING CUM SELF DECLARATION 
(FOR CLAIMING SUBSIDY UNDER FAME-II SCHEME) 
I hereby apply for subsidy under the Phase-II of Faster  Adoption and Manufacturing of Hybrid and Electric  Vehicles (“FAME-II”) Scheme for the purchase of Ola S1  / Ola S1 Pro (“Vehicle”) from Ola Electric Technologies  Private Limited (“Ola Electric”) and declare that: 

1. I have read and understood the <FAME-II Scheme>  and the eligibility criteria for availing the subsidy  benefit therein. 

2. I am purchasing an electric two-wheeler for the first  time and/or I have not availed the subsidy under  the FAME-II Scheme for purchase of an electric two- wheeler till date. 

3. I understand and accept that if at any stage, it is  found that the information given by me is false /  incorrect, the benefit of subsidy under the FAME-II  Scheme will not be available to me and I will have  to pay the balance amount in respect of the Vehicle  to the extent of the subsidy availed by me. 

4. I fully understand that I will not be entitled to the  delivery / possession of the Vehicle till such time I  pay the purchase price in full to Ola Electric. `

const TermsConditions = () => {

  // const history = useHistory()
  useEffect(() => {
  }, []);

  return (
    <div className="terms-main">
   
      <div className="policy_back_icon">
          <Link to={'/'}>
            <img src={backIcon} className="back-icon" />
          </Link>
        </div>


      <div className="heading-text">Terms & Conditions</div>
      <div className="grey-text" style={{ whiteSpace: "pre-line" }}>{terms}</div>
    </div>
  );
};

export default TermsConditions;
